exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-modal {\n  width: 95%;\n}\n@media screen and (max-width: 480px) {\n.dashboard-modal {\n    width: 100%;\n}\n}", ""]);

// exports
